export default function(manifestText) {
  try {
    const parser = new DOMParser();
    const manifestType = parser
      .parseFromString(manifestText, 'text/xml')
      .getElementsByTagName('MPD')[0]
      .attributes.getNamedItem('type').value;
    return manifestType !== 'static';
  } catch (e) {
    // Improperly formatted DASH manifest
    // Error on the side of reporting as LIVE
    return true;
  }
}
